export default __webpack_public_path__ + "static/hot_tub_3-31b0d2f4b99dc56788bdc89ebc3eb429.jpg";